import React from 'react';
import { Text, Stack } from '@amzn/orion-components';
import './header.scss';

interface PageHeaderProps {
  title?: string;
  subtitle?: string;
  description?: string;
}

export const PageHeaderOrion: React.FC<PageHeaderProps> = ({ title, subtitle, description }) => {
  return (
    <div className="landing-header">
      <div className="header-container">
        <Stack direction="vertical" gap="sm" style={{ maxWidth: '83%' }}>
          <Text as="h1" fontSize="4xl" fontWeight="bold" color="#ffffff">
            {title}
          </Text>
          {subtitle && (
            <Text as="h2" fontSize="lg" color="rgba(255,255,255,0.9)">
              {subtitle}
            </Text>
          )}
          {description && (
            <Text as="p" fontSize="base" color="rgba(255,255,255,0.85)">
              {description}
            </Text>
          )}
        </Stack>
      </div>
    </div>
  );
};
